module.exports = __webpack_public_path__ + "static/media/travelingbymoto1.e99cf076.png";